// Bookmarked URLs and saved Dashboard filters from older releases still carry this value.
const LEGACY_ALL_DOMAINS = '__all__';

export function readDomainParam(domain?: string | null): string | undefined {
  return domain && domain !== LEGACY_ALL_DOMAINS ? domain : undefined;
}
